import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Data from '../../data';
import Footer from '../../ui/layout/Footer.component';
import { Section, SectionBody } from '../../ui/layout/Section.component';
import Spinner from '../../ui/Spinner.component';
import AddCarrierHeader from '../AddCarrierHeader.component';

const { Carrier } = Data;

const UpsEulaAgreement = ({
	type,
	coreData,
	isLoading,
	carrierCallback,
	formatTradeMark,
	communicationError,
	returnToAddUpsAccount,
	enterpriseLocations,
}) => {
	useEffect(() => {
		if (type === 'single' && communicationError) {
			returnToAddUpsAccount();
		}
	}, [communicationError, returnToAddUpsAccount, type]);

	const onAcceptButtonClick = () => {
		if (type === 'single') {
			carrierCallback(true, coreData);
		} else {
			carrierCallback(true);
		}
	};

	const onCancelButtonClick = () => {
		carrierCallback(false);
	};

	const headerText = (
		<ol>
			To start shipping with UPS, you must first agree to the following:
			{type === 'combined' && (
				<li>
					<a
						className="ups-promotional-and-technology-agreement-link"
						href="https://www.ups.com/assets/resources/media/en_US/UPS_DAP_TC.pdf"
						target="_blank"
						rel="noreferrer noopener"
					>
						The UPS Promotional Rates Agreement.
					</a>
				</li>
			)}
			<li>
				<a
					className="ups-technology-agreement-link"
					href="https://www.ups.com/assets/resources/media/en_US/UTA.pdf"
					target="_blank"
					rel="noreferrer noopener"
				>
					The UPS Technology Agreement.
				</a>
			</li>
			<li>
				<a
					className="ups-technology-agreement-link"
					href="https://www.ups.com/us/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page"
					target="_blank"
					rel="noreferrer noopener"
				>
					List of Prohibited Articles.
				</a>
			</li>
		</ol>
	);

	return (
		<div className="common-carrier-eula">
			<Section>
				<AddCarrierHeader
					title={
						type === 'single'
							? 'Technology Agreement'
							: 'Promotional Rates and Technology Agreements'
					}
					carrier={Carrier.UPS}
					subtitle={headerText}
				/>
				<SectionBody />
				<Footer
					primary={{
						label: 'I Accept',
						onClick: onAcceptButtonClick,
						disabled: isLoading,
						dataqa: 'ups-eula-agreement-accept',
					}}
					secondary={{
						label: enterpriseLocations ? 'Start Over' : 'Cancel',
						onClick: onCancelButtonClick,
						dataqa: `ups-eula-agreement-${
							enterpriseLocations ? 'start-over' : 'cancel'
						}`,
					}}
				>
					{formatTradeMark('footer')}
				</Footer>
				{isLoading && <Spinner msg="Connecting UPS Account..." />}
			</Section>
		</div>
	);
};

export default UpsEulaAgreement;

UpsEulaAgreement.propTypes = {
	// Determines to render just the Promotional Rates or the Promotional Rates and Technology Agreements (single or combined)
	type: PropTypes.string.isRequired,

	// (Optional) Data for UPS core account user
	coreData: PropTypes.object,

	// (Optional) Determine button disabled state
	isLoading: PropTypes.bool,

	// Callback to determine next step
	carrierCallback: PropTypes.func.isRequired,

	// Function that renders the footer text
	formatTradeMark: PropTypes.func.isRequired,

	// (Optional) Determines if the previous AddUpsAccount component should be rendered
	communicationError: PropTypes.bool,

	// (Optional) Returns to the AddUpsAccount component
	returnToAddUpsAccount: PropTypes.func,
};
